import { css } from '@emotion/css';
import { ColorVariables } from '@group-link-one/gl-ui/sonarprint';

export const MainContainer: string = css`
  width: 100vw;
  height: 100vh;
  display: flex;
  background: ${ColorVariables.COLOR.COLOR_QUINARY_BACKGROUND};
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftContainer: string = css`
  display: flex;
  align-items: center;
  justify-content: center;

  picture {
    height: 100%;
  }

  @media (min-width: 769px) {
    height: 100vh;
  }

  @media (max-width: 768px) {
    width: 100%;
    /* flex-shrink: 0; */
  }
`;

export const ArtContainer: string = css`
  width: 100%;
  height: 100%;
  max-height: 100vh;
  object-fit: contain;
  object-position: center;

  @media (max-width: 768px) {
    width: 100vw;
    height: 30px;
    object-fit: cover;
  }
`;

export const RightContainer: string = css`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  @media (min-width: 769px) {
    flex: 1;
    width: 100%;
    height: 100vh;
    padding: 80px 60px 64px 60px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 0;
    padding: 30px 20px;
  }
`;

export const LogoContainer: string = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-bottom: 30px;
  justify-content: center;

  @media (max-width: 768px) {
    margin-bottom: 60px;
  }
`;

export const Logo: string = css`
  width: 210px;

  @media (max-width: 768px) {
    width: 136px;
  }
`;

export const ContentContainer: string = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 20px 0;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 10px 0;
  }
`;

export const Footer: string = css`
  text-align: center;
  font-size: 12px;
  color: ${ColorVariables.BASE.BASE_COLOR_PRIMARY_TEXT};
  flex-shrink: 0;
  padding: 0px 0;

  @media (max-width: 768px) {
    margin-top: 20px;
    padding: 15px 0;
  }
`;
